import { render } from "./Services.vue?vue&type=template&id=56f79601&ts=true"
import script from "./Services.vue?vue&type=script&lang=ts"
export * from "./Services.vue?vue&type=script&lang=ts"

import "./Services.vue?vue&type=style&index=0&id=56f79601&scope=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__